import { useState } from "react";
import { Menu, X, Sun, Moon } from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";
import { BrandLogo } from "@/components/shared/BrandLogo";

// Desktop e mobile compartilham a mesma lista.
const navItems = [
  { label: "Serviços", href: "/servicos" },
  { label: "Automação", href: "/automacao-empresarial" },
  { label: "Produtos", href: "/produtos" },
  { label: "Cases", href: "/projetos" },
  { label: "Blog", href: "/blog" },
  { label: "Sobre", href: "/sobre" },
  { label: "Contato", href: "/contato" },
];

const NavbarNew = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  const ThemeButton = () => (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label="Alternar tema"
      className="inline-flex h-9 w-9 items-center justify-center rounded-[10px] border border-border bg-card text-muted-foreground transition hover:brightness-[.94]"
    >
      {theme === "light" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );

  return (
    <header className="sticky top-0 z-30 border-b border-border bg-card">
      <div className="mx-auto flex h-[68px] max-w-[1180px] items-center gap-8 px-8 max-[900px]:px-5">
        <Link to="/" className="flex shrink-0 items-center">
          <BrandLogo className="h-[30px]" />
        </Link>

        {/* Colapsa pro menu mobile em ~1000px, como o mockup */}
        <nav className="hidden flex-1 items-center gap-[26px] min-[1001px]:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              className={({ isActive }) =>
                `whitespace-nowrap text-sm font-semibold transition-colors ${
                  isActive
                    ? "font-bold text-foreground"
                    : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex-1 min-[1001px]:hidden" />

        <div className="flex items-center gap-2.5">
          <ThemeButton />
          {/* Below ~560px the pill no longer fits next to the logo + theme +
              menu button and ends up covering the hamburger (caught by the
              mobile smoke test). The hero carries the same CTA, so it can go. */}
          <Link
            to="/contato"
            className="inline-flex h-[38px] items-center whitespace-nowrap rounded-full bg-primary px-[17px] text-[13px] font-bold text-primary-foreground transition hover:brightness-[.94] max-[560px]:hidden"
          >
            Diagnóstico gratuito
          </Link>
          <button
            type="button"
            onClick={() => setIsOpen((v) => !v)}
            aria-label={isOpen ? "Fechar menu" : "Abrir menu"}
            aria-expanded={isOpen}
            className="inline-flex h-[38px] w-[38px] items-center justify-center rounded-[10px] border border-border bg-card text-foreground min-[1001px]:hidden"
          >
            {isOpen ? <X className="h-[18px] w-[18px]" /> : <Menu className="h-[18px] w-[18px]" />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="border-t border-border min-[1001px]:hidden">
          <div className="mx-auto flex max-w-[1180px] flex-col gap-0.5 px-8 pb-5 pt-3.5 max-[900px]:px-5">
            {navItems.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `rounded-[10px] px-3 py-[13px] text-[15px] font-semibold hover:bg-muted ${
                    isActive ? "text-primary" : "text-foreground"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contato"
              onClick={() => setIsOpen(false)}
              className="mt-3 inline-flex h-12 items-center justify-center rounded-full bg-primary text-[14.5px] font-bold text-primary-foreground"
            >
              Diagnóstico gratuito
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default NavbarNew;
